export type StatsModalType =
  | 'attendance'
  | 'absence'
  | 'device'
  | 'punishment'
  | 'total'

export enum StatsDetailsTabEnum {
  /**
   * 导生档案
   */
  StudentProfiles = 'StudentProfiles',
  /**
   * 学生近况 - 总统计
   */
  StudentOverview = 'StudentOverview',
  /**
   * 学生近况 - 异常考勤
   */
  StudentAttendance = 'StudentAttendance',
  /**
   * 学生近况 - 请假
   */
  StudentAbsence = 'StudentAbsence',
  /**
   * 学生近况 - 电子设备违规
   */
  StudentDeviceViolation = 'StudentDeviceViolation',
  /**
   * 学生近况 - 静校管理
   */
  StudentStaticManagement = 'StudentStaticManagement',
  /**
   * 学生近况 - 处分
   */
  StudentPunishment = 'StudentPunishment',
  /**
   * 学生近况 - 今日学生异常考勤
   */
  StudentDailyAttendance = 'StudentDailyAttendance',
  /**
   * 学生近况 - 平板使用记录
   */
  StudentPadUsageRecord = 'StudentPadUsageRecord',
  /**
   * 学生近况 - 外卖违规
   */
  StudentTakeoutViolation = 'StudentTakeoutViolation',
  /**
   * 学生近况 - 乘梯违规
   */
  StudentLiftViolation = 'StudentLiftViolation',

  /**
   * 教师近况 - 教师考勤
   */
  TeacherAttendance = 'TeacherAttendance',

  /**
   * 教师近况 - 课程班评价项发布明细
   */
  CourseAssessmentItemDetails = 'CourseAssessmentItemDetails',

  /**
   * 学业统计 - 选科情况
   */
  AcademicSelectedSubjects = 'AcademicSelectedSubjects',
  /**
   * 学业统计 - 课程任务
   */
  AcademicCourseTasks = 'AcademicCourseTasks',
  /**
   * 学业统计 - 课程成绩
   */
  AcademicCourseGrades = 'AcademicCourseGrades',
  /**
   * 学业统计 - 考试成绩
   */
  AcademicExamGrades = 'AcademicExamGrades',
  /**
   * 综合分析
   */
  AcademicAnalysis = 'AcademicAnalysis',
}

/**
 * 时间范围 本周、上周、本月、本学期、今日
 */
export type TimeRange = 'week' | 'last-week' | 'month' | 'semester' | 'today'

export type UserGatewayParams = {
  UserGateway: null
}

export type GatewayModalParams = {
  GatewayStatsDetails: {
    type: StatsDetailsTabEnum
    timeRange?: TimeRange
  }
  // 选科绩点详情
  GatewayGpaDetails: null
  // 九科绩点详情
  GatewayNineGpaDetails: null
  // 0 分几点，
  GatewayZeroCreditDetails: null
}
